import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Auth Service
 * Kullanıcıya özel otobüs işlemleri (yolcu listesi vb.)
 */
export const busAuthService = {
  /**
   * Kullanıcının kayıtlı yolcularını getirir.
   * @param {Object} payload
   * @param {number} payload.UserId
   * @param {string} [payload.LanguageCode="tr"]
   * @param {number} [payload.AppVersion=0]
   * @param {Object} headers
   * @param {boolean} hasErrorHandler
   */
  getPassengers: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) => {
    const normalizedPayload = {
      LanguageCode: "tr",
      AppVersion: 0,
      ...payload,
    };

    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.auth.getPassengers,
      payload: normalizedPayload,
      headers,
      hasErrorHandler,
    });
  },
};

